export const stateName = 'businessAddresses';